import styles from './businessCard.module.scss'

function BusinessCard() {
    return (
        <div className={styles.scene}>
            <div className={styles.card}>

                <div className={styles.front}>
                    <img src="images/logo.svg" className={styles.frontLogo} alt="Ulmsoft" />
                    <div className={styles.frontTagline}>Website Development</div>
                </div>

                <div className={styles.back}>
                    <div className={styles.backBody}>

                        <div className={styles.backHeader}>
                            <div className={styles.backBranding}>
                                <img src="images/logo.svg" className={styles.backLogo} alt="Ulmsoft" />
                                <div className={styles.backTagline}>Website Development</div>
                            </div>
                        </div>

                        <div className={styles.backPerson}>
                            <div className={styles.personName}>Tudor Ulmeanu</div>
                            <div className={styles.personTitle}>CEO / Founder</div>
                        </div>

                        <div className={styles.backContact}>
                            <div className={styles.contactLine}>077 4377 6211</div>
                            <div className={styles.contactLine}>tudor.ulmeanu@yahoo.com</div>
                            <div className={styles.contactLine}>www.ulmsoft.co.uk</div>
                        </div>

                        <div className={styles.location}>Manchester, UK</div>
                    </div>

                    <div className={styles.navyBar} />
                </div>

            </div>
        </div>
    );
}

export default BusinessCard;
